import { ToolOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export function Placeholder({ title, description }: { title: string; description: string }) {
  const navigate = useNavigate();
  return (
    <Result
      icon={<ToolOutlined />}
      title={title}
      subTitle={`${description}。该模块正在建设中。`}
      extra={<Button onClick={() => navigate("/")}>返回首页</Button>}
    />
  );
}
